export const MOCK_STOCKS = [
  { date: new Date('2026-02-10'), t: '2026-02-10', h: 185.20, l: 180.10, c: 182.50, v: 50000000 },
  { date: new Date('2026-02-11'), t: '2026-02-11', h: 188.40, l: 182.00, c: 187.10, v: 45000000 },
  { date: new Date('2026-02-12'), t: '2026-02-12', h: 190.10, l: 186.50, c: 189.20, v: 60000000 },
  { date: new Date('2026-02-13'), t: '2026-02-13', h: 187.30, l: 184.20, c: 185.50, v: 35000000 },
  { date: new Date('2026-02-16'), t: '2026-02-16', h: 192.50, l: 187.00, c: 191.80, v: 55000000 }
];